<template>
  <div id="app">
    <Loading />
    <Globe/>
    <Logo class="logo" v-if="showLogo"/>
    <component v-bind:is="whichNav" v-if="($vuetify.breakpoint.mdAndUp || currentRouteName!=='Work')"/>
    <router-view/>
  </div>
</template>
<script>
import Globe from '@/components/Globe.vue'
import DesktopNav from '@/components/DesktopNav.vue'
import MobileNav from '@/components/MobileNav.vue'
import Logo from '@/components/Logo.vue'
import Loading from '@/components/Loading.vue'
export default {
  components: {
    Globe,
    DesktopNav,
    MobileNav,
    Logo,
    Loading
  },
  data () {
    return {
      guides: false
    }
  },
  computed: {
    whichNav () { return (this.$vuetify.breakpoint.smAndDown) ? 'mobileNav' : 'desktopNav' },
    opacity () { return this.$store.state.animations.logo.opacity },
    transform () { return 'translateY(' + (this.$store.state.animations.logo.translateY).toString() + 'px)' },
    currentRouteName () {
      return this.$route.name
    },
    showLogo () {
      let theReturn
      switch (this.currentRouteName) {
        case 'Work': //
          theReturn = this.$vuetify.breakpoint.mdAndUp
          break
        case 'Home':
          theReturn = this.$vuetify.breakpoint.mdAndUp
          break
        default:
          theReturn = true
          break
      }
      // return (this.$vuetify.breakpoint.mdAndUp || this.currentRouteName !== 'Work')
      return theReturn
    }
  },
  watch: {
    whichNav (newValue, oldValue) {
      console.log(newValue)
    }
  },
  mounted () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
    this.$nextTick(function () {
      const preloadImages = []
      const preloadImagesMobile = []
      const slideData = [
        { title: 'Interactive', src: require('@/assets/slide1-desktop.png'), srcMobile: require('@/assets/slide1-mobile.png'), alt: 'phone' },
        { title: 'Non-profits', src: require('@/assets/slide2.svg'), srcMobile: require('@/assets/slide2-mobile.svg'), alt: 'laptop' },
        { title: 'Educational', src: require('@/assets/slide3-desktop.png'), srcMobile: require('@/assets/slide3-mobile.svg'), alt: 'two phones' },
        { title: 'Branding', src: require('@/assets/slide4-desktop.png'), srcMobile: require('@/assets/slide4-mobile.png'), alt: 'devices' }
      ]
      slideData.forEach((slide, i) => {
        if (this.$vuetify.breakpoint.mdAndUp) {
          preloadImages[i] = new Image()
          preloadImages[i].src = slide.src
        } else {
          preloadImagesMobile[i] = new Image()
          preloadImagesMobile[i].src = slide.srcMobile
        }
      })
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');
*{
  margin: 0;
  padding: 0;
  // overflow: hidden;
}

#app {
  font-family: 'Poppins', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  width: 100vw;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  background-color: #74B0DE;
}
  .grid{
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    z-index: 1000;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    >div{
      border: 1px solid black;
    }
  }
</style>
